<template>
  <div class="notfound-page">
    <div class="page-inner">
      <!-- 상단 배너 -->
      <section class="hero-banner">
        <div class="hero-badge">ERROR PAGE</div>

        <div class="hero-content">
          <h1 class="hero-title">404</h1>
          <p class="hero-desc">
            요청하신 페이지를 찾을 수 없습니다.<br />
            주소가 변경되었거나 삭제되었을 수 있습니다.
          </p>

          <button class="btn-home" @click="goHome">홈으로 이동</button>
        </div>
      </section>
    </div>
  </div>
</template>

<script>
export default {
  name: "NotFoundView",
  methods: {
    goHome() {
      this.$router.push("/");
    }
  }
};
</script>

<style scoped>
.notfound-page {
  min-height: 100vh;
  background: #f4f7fb;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 16px;
}

.page-inner {
  width: 100%;
  max-width: 720px;
}

/* 상단 배너 */
.hero-banner {
  position: relative;
  overflow: hidden;
  border-radius: 24px;
  padding: 48px 32px;
  background: linear-gradient(135deg, #2563eb, #1d4ed8 55%, #1e40af);
  color: #ffffff;
  text-align: center;
  box-shadow: 0 14px 36px rgba(37, 99, 235, 0.28);
}

.hero-badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  height: 32px;
  padding: 0 14px;
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.18);
  font-size: 13px;
  font-weight: 700;
  margin-bottom: 18px;
}

.hero-title {
  margin: 0;
  font-size: 72px;
  font-weight: 900;
  line-height: 1;
}

.hero-desc {
  margin: 16px 0 28px;
  font-size: 16px;
  line-height: 1.7;
  color: rgba(255, 255, 255, 0.9);
}

/* 버튼 */
.btn-home {
  height: 48px;
  padding: 0 28px;
  border-radius: 12px;
  font-size: 15px;
  font-weight: 800;
  border: none;
  cursor: pointer;
  background: #ffffff;
  color: #1d4ed8;
  transition: 0.2s ease;
}

.btn-home:hover {
  background: #e0ecff;
}

/* 반응형 */
@media (max-width: 768px) {
  .hero-banner {
    padding: 36px 20px;
    border-radius: 18px;
  }

  .hero-title {
    font-size: 56px;
  }

  .hero-desc {
    font-size: 15px;
  }
}
</style>
